import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import CustomCheckoutSignupStepper from "./CheckoutSignupStepper";

const CheckoutSignupPage8: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ safeNavigate to avoid duplicate navigation
  const safeNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  useEffect(() => {
    const step4Completed = localStorage.getItem("step-4-completed");
    if (step4Completed) {
      safeNavigate("/glp1/getting-started/step-5");
    } else {
      safeNavigate("/glp1/getting-started/step-4");
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };
  const handleBack = () => {
    safeNavigate("/glp1/getting-started/step-4");
  };

  const handleNext = () => {
    if (selectedOption) {
      localStorage.setItem(
        "weight_loss_medication",
        JSON.stringify({
          key: "weight_loss_medication",
          value: selectedOption,
        })
      );
    }
    safeNavigate("/glp1/getting-started/step-6");
    localStorage.setItem("step-5-completed", "true");
  };

  useEffect(() => {
    const savedWeightLoss = localStorage.getItem("weight_loss_medication");

    if (savedWeightLoss) {
      const parsedWeightLoss = JSON.parse(savedWeightLoss);
      setSelectedOption(parsedWeightLoss.value);
    }
  }, []);

  const options = ["Yes", "No"];

  return (
    <PageWrapper onBack={handleBack}>
      <div className="signup-page-container container">
        <CustomCheckoutSignupStepper activeStep={1} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-content-header">
            Are you currently taking or have recently (within the last 12
            months) taken medication (GLP-1 or non-GLP1) for weight loss?
          </p>
          <div className="options options-box-contents">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={!selectedOption}
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default CheckoutSignupPage8;
